import { Component, OnInit, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Periodicity } from 'src/app/Models/Handbooks/Periodicity';
import { HandbookDescriptor } from 'src/app/Models/Handbooks/Base/HandbookDescriptor';
import { OAuthService } from 'angular-oauth2-oidc';

import { AppComponent } from '../../app.component'
import { TranslatePipe } from 'src/app/Pipes/TranslatePipe';
import { CurrentLangPipe } from 'src/app/Pipes/CurrentLangPipe';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-sidebar',
    templateUrl: './Sidebar.html',
    styleUrls: ['./Sidebar.less'],
    providers: [TranslatePipe, CurrentLangPipe, CookieService]
})
export class SidebarComponent implements OnInit, AfterViewInit {
    private periodicitiesLoaded: boolean = false;
    Periodicities: Array<Periodicity> = [];
    getPeriodicities() {
        return this.http.get(`${environment.apiUrl}/api/Periodicities/List`, {
            headers: { "Content-Type": "application/json" }
        });
    }

    public GivenName: string = '';

    public FamilyName: string = '';

    public Email: string = '';

    public ApiVersion: string = '';

    getProfile() {
        AppComponent.afterLoginedOnce.push(() => {
            AppComponent.oauthServiceStatic.loadUserProfile().then(() => {
                let claims = AppComponent.oauthServiceStatic.getIdentityClaims();
                // console.log(claims)
                this.GivenName = claims['given_name']
                this.FamilyName = claims['family_name']
                this.Email = claims['email']
                let _rolesResolver: string = '';
                if (Array.isArray(claims['role'])) {
                    _rolesResolver = claims['role'].join(' ');
                } else {
                    if ('string' === typeof claims['role']) {
                        _rolesResolver = claims['role'];
                    }
                }
                if (_rolesResolver.trim() != '') {
                    this.cookieService.set(
                        btoa('roles').replace('=', ''),
                        btoa(_rolesResolver),
                        claims['exp']
                    )
                }
            })
        })
    }

    UserMenuItems: MenuItem[] = [
        {
            label: this.translatePipe.transform('common.user'),
            items: [
                {
                    label: this.translatePipe.transform('user.profile'),
                    icon: 'fas fa-user',
                    command: () => { this.navigateToProfile(); }
                },
                {
                    label: this.translatePipe.transform('user.logout'),
                    icon: 'fas fa-sign-out-alt',
                    command: () => { this.logout(); }
                },
            ]
        },
        {
            label: this.translatePipe.transform('changeLang.changeLanguage'),
            items: [
                {
                    label: this.translatePipe.transform('changeLang.kazakh'),
                    icon: this.currentLangPipe.get() == 'kk' ? 'fas fa-check' : 'fas fa-globe',
                    disabled: this.currentLangPipe.get() == 'kk',
                    command: () => { this.currentLangPipe.changeTo('kk').then(() => { location.reload(); }); }
                },
                {
                    label: this.translatePipe.transform('changeLang.russian'),
                    icon: this.currentLangPipe.get() == 'ru' ? 'fas fa-check' : 'fas fa-globe',
                    disabled: this.currentLangPipe.get() == 'ru',
                    command: () => { this.currentLangPipe.changeTo('ru').then(() => { location.reload(); }); }
                },
                {
                    label: this.translatePipe.transform('changeLang.english'),
                    icon: this.currentLangPipe.get() == 'en' ? 'fas fa-check' : 'fas fa-globe',
                    disabled: this.currentLangPipe.get() == 'en',
                    command: () => { this.currentLangPipe.changeTo('en').then(() => { location.reload(); }); }
                }
            ]
        },
    ];

    IndicatorsExpanded: MenuItem[] = [
        {
            label: this.translatePipe.transform('sidebar.masterDataManagementSubSystem'),
            items: [
                {
                    label: this.translatePipe.transform('actions.editing'),
                    icon: 'fas fa-pencil-alt',
                    routerLink: ['/Indicators/List']
                },
            ]
        }
    ];
    IndicatorsPlannedExpanded: MenuItem[] = [
        {
            label: this.translatePipe.transform('sidebar.plannedFactorsAccountingSubSystem'),
            items: [
                {
                    label: this.translatePipe.transform('actions.editing'),
                    icon: 'fas fa-pencil-alt',
                    routerLink: ['/Indicators/Planned']
                },
            ]
        }
    ];
    IndicatorsPublicExpanded: MenuItem[] = [
        {
            label: this.translatePipe.transform('sidebar.publicDataManagementSubSystem'),
            items: [
                {
                    label: this.translatePipe.transform('sidebar.publication'),
                    icon: 'fas fa-share-alt',
                    routerLink: ['/Indicators/Planned']
                },
            ]
        }
    ];
    FactorsByPeriodicity: MenuItem[] = [];
    FactorsByPeriodicityExpanded: MenuItem[] = [];

    Handbooks: MenuItem[] = [];
    HandbooksExpanded: MenuItem[] = [];

    CurrentRouteUrl: string = ''

    constructor(
        private http: HttpClient,
        private ref: ChangeDetectorRef,
        private router: Router,
        private route: ActivatedRoute,
        private oauthService: OAuthService,
        private translatePipe: TranslatePipe,
        private currentLangPipe: CurrentLangPipe,
        private cookieService: CookieService,
    ) {
        this.ApiVersion = environment.selfRedirect;
    }

    ngOnInit() {
        this.router.events.forEach(x => {
            if(x instanceof NavigationEnd) {

                let lang: string = this.currentLangPipe.get();

                this.Handbooks = [
                    ...(HandbookDescriptor.StaticList().map(x => ({
                        icon: x.Icon,

                        label: (lang == 'ru')
                            ? x.NameRu
                            : (lang == 'kk')
                                ? x.NameKz
                                : x.NameEn,

                        style: this.router.url == `/Handbooks/${x.Id}`
                            ? { backgroundColor: 'rgb(196, 207, 236)', borderRadius: '0px' }
                            : {},
                        routerLink: `Handbooks/${x.Id}`
                    }))),
                    {
                        icon: 'fas fa-project-diagram',
                        label:  this.translatePipe.transform('sidebar.industries'),
                        style: this.router.url == `/HandbooksIndustries`
                            ? { backgroundColor: 'rgb(196, 207, 236)', borderRadius: '0px' }
                            : {},
                        routerLink: `HandbooksIndustries`
                    }
                ]
                this.HandbooksExpanded = [
                    {
                        label: this.translatePipe.transform('sidebar.handbooksManagementSubSystem'),
                        items: this.Handbooks
                    }
                ]
                
                this.CurrentRouteUrl = this.router.url

                let _reformatPeriodicities = () => {

                    this.FactorsByPeriodicity = [
                        {
                            label: this.translatePipe.transform('sidebar.actualIndicators'),
                            items: this.Periodicities.sort((a, b) => a.Id - b.Id).map(x => ({

                                label: (lang == 'ru')
                                    ? x.NameRu
                                    : (lang == 'kk')
                                        ? x.NameKz
                                        : x.NameEn,
                                
                                icon: 'fas fa-calendar',
                                style: this.router.url == `/FactorsPeriods/${x.Id}`
                                    ? { backgroundColor: 'rgb(196, 207, 236)', borderRadius: '0px' }
                                    : {},
                                routerLink: [`FactorsPeriods/${x.Id}`]
                            }))
                        },
                        {
                            label: this.translatePipe.transform('actions.others'),
                            items: [
                                { label: this.translatePipe.transform('actions.import'), icon: 'fas fa-file-import', disabled: true },
                            ]
                        }
                    ]
                    this.FactorsByPeriodicityExpanded = [
                        { label: this.translatePipe.transform('sidebar.dynamicFactorsInputSubSystem'), },
                        { separator: true },
                        ...(this.FactorsByPeriodicity)
                    ]
                }                

                if (!this.periodicitiesLoaded) {
                    AppComponent.afterLoginedOnce.push(() => {
                        this.getPeriodicities().subscribe((data: Array<Periodicity>) => {
                            this.periodicitiesLoaded = true;
                            this.Periodicities = data;
                            _reformatPeriodicities()
                        })
                    })
                } else {
                    _reformatPeriodicities()
                }

                this.getProfile();
            }
        })
        
    }

    logout() {
        AppComponent.afterLoginedOnce.push(() => {
            this.cookieService.delete(
                btoa('roles').replace('=', '')
            )
            AppComponent.oauthServiceStatic.logOut();
        })
    }

    navigateToProfile() {
        window.location.href = environment.issuerAuthority + '/grants'
    }

    ngAfterViewInit() { }

}